<template>
  <div>
    <gallery v-if="showGallery && galleryImages" :images="galleryImages" />
    <split-screen>
      <template v-slot:left>
        <div>
          <ul class="mb-12">
            <li v-for="(artist, count) in artists" :key="count">
              <router-link :to="`/artists/${artist.slug}`"><BaseCircle class="hidden inline mr-3 mb-1 h-6" />{{ artist.title }}</router-link>
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:right>
        <div v-if="artists && currentArtist" class="content mt-16 p-8 mb-16">
          <!-- <h3>{{ currentArtist.title }}</h3> -->
          <div class="artist-image" v-for="(image, count) in artistImages" :key="count">
            <span v-html="image.medium" />
            <div class="text-xs mt-1" v-if="image.caption" v-html="image.caption" />
          </div>
          <div class="header-styled mt-6" v-html="currentArtist[`description_${lang}`]" />
          <div class="f-serif text-sm mt-6" v-html="currentArtist[`details_${lang}`]" />

          <div v-if="artistVideos">
            <h3 class="border-b border-black mt-12 mb-6 pb-3">Videos</h3>
            <div v-for="(video, count) in artistVideos" :key="count">
              <BaseResponsiveEmbed :url="video.url" />
            </div>
          </div>

          <BaseRelated v-if="artistEvents.length" class="mt-16" heading="Related Events" :items="artistEvents" />
        </div>
        <bounce v-else />
      </template>
    </split-screen>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SplitScreen from '@/views/SplitScreen'
import Bounce from '@/components/Bounce'
import Gallery from '@/components/Gallery'

export default {
  name: 'Artists',
  data () {
    return {
      artists: false,
      showGallery: false
    }
  },
  components: {
    Bounce,
    Gallery,
    SplitScreen
  },
  mounted () {
    fetch(`${process.env.VUE_APP_API_ROOT}en/artists.json`)
      .then(res => res.json())
      .then(json => this.artists = json)
  },
  computed: {
    ...mapState(['lang']),
    currentArtist () {
      return this.artists.find(x => {
        return x.slug === this.$route.params.slug
      })
    },
    artistEvents () {
      return this.$store.getters.getEventsByArtistSlug(this.currentArtist.slug)
    },
    artistImage () {
      if (this.currentArtist && this.currentArtist.images.length) {
        return this.currentArtist.images[0].medium
      } else {
        return false
      }
    },
    artistImages () {
      if (this.currentArtist && this.currentArtist.images.length) {
        return this.currentArtist.images
      } else {
        return false
      }
    },
    artistVideos () {
      if (this.currentArtist && this.currentArtist.videos.length) {
        return this.currentArtist.videos
      } else {
        return false
      }
    },
    galleryImages () {
      if (this.artists) {
        return this.artists.map(x => {
          if (x.images.length) {
            return x.images[0].large
          } else {
            return false
          }
        })
      } else {
        return false
      }
    },
    description () {
      if (this.lang === 'en') {
        return this.currentArtist.description_en
      } else {
        return this.currentArtist.description_fr
      }
    }
  },
  methods: {
    openGallery () {
      // this.showGallery = true
    }
  }
}
</script>

<style lang="stylus">
  a:hover .hidden, .router-link-exact-active .hidden
    display: inline-block

  .artist-image img
    @apply w-full
</style>
